import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import ShopPage from './pages/ShopPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import InterestList from './pages/InterestList';
import Admin from './pages/Admin';
import Orders from './pages/Orders';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import TermsAndConditions from './pages/TermsAndConditions';
import QuoteSelection from './pages/QuoteSelection';
import AdvancedQuote from './pages/AdvancedQuote';
import SimpleQuote from './pages/SimpleQuote';
import ThankYou from './pages/ThankYou';
import QuoteDetails from './pages/QuoteDetails';
import OrderDetails from './pages/OrderDetails';
import AdminQuoteDetails from './pages/AdminQuoteDetails';
import AdminOrderDetails from './pages/AdminOrderDetails';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { SidebarProvider } from './context/SidebarContext';
import { InterestListProvider } from './context/InterestListContext';
import { AuthProvider } from './context/AuthContext';
import { initGA, trackPageView } from './utils/analytics';
import React, { useState, useEffect } from 'react';

// Componente para tracking automático de páginas
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track página vista quando a rota muda
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");

  // Inicializar Google Analytics
  useEffect(() => {
    // Inicializar apenas em produção ou quando não for localhost
    if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
      initGA();
      trackPageView(window.location.pathname + window.location.search);
    }
  }, []);

  const handleCategoryFilter = (category) => {
    setCategoryFilter(category);
  };

  const clearCategoryFilter = () => {
    setCategoryFilter("");
  };

  return (
    <HelmetProvider>
      <div className="App">
      <AuthProvider>
        <InterestListProvider>
          <SidebarProvider>
            <Router>
                <ScrollToTopOnRouteChange />
                <AnalyticsTracker />
                <Navbar 
                search={search} 
                setSearch={setSearch}
                onCategoryFilter={handleCategoryFilter}
              />
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={
                <ShopPage 
                  search={search} 
                  categoryFilter={categoryFilter}
                  onClearFilter={clearCategoryFilter}
                />
              } />
              <Route path="/lista-interesse" element={<InterestList />} />
              <Route path="/orders" element={<Orders />} />
              
              {/* Rotas protegidas do Admin */}
              <Route path="/admin" element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
              <Route path="/admin/quote/:id" element={
                <ProtectedRoute>
                  <AdminQuoteDetails />
                </ProtectedRoute>
              } />
              <Route path="/admin/order/:id" element={
                <ProtectedRoute>
                  <AdminOrderDetails />
                </ProtectedRoute>
              } />
              
              {/* Rotas normais */}
              <Route path="/quote/:id" element={<QuoteDetails />} />
              <Route path="/order/:id" element={<OrderDetails />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/produtos/:category/:slug" element={<ProductDetail />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/contactos" element={<Contact />} />
              <Route path="/termos-e-condicoes" element={<TermsAndConditions />} />
              <Route path="/orcamento" element={<QuoteSelection />} />
              <Route path="/orcamento/avancado" element={<AdvancedQuote />} />
              <Route path="/orcamento/simples" element={<SimpleQuote />} />
              <Route path="/orcamento/obrigado" element={<ThankYou />} />
              
              {/* Página 404 - DEVE SER A ÚLTIMA ROTA */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <ScrollToTop />
          </Router>
        </SidebarProvider>
      </InterestListProvider>
    </AuthProvider>
    </div>
    </HelmetProvider>
  );
}

export default App;
